// extracted by mini-css-extract-plugin
export default {"background":"ZM","weightImage":"aN","drinkImage":"bN","content":"cN","rtbLeft":"eN","rtbRight":"fN","rtbLeftMobile":"gN","imageContainer":"hN","rtbBox":"iN","line":"jN","rtbDesktop":"kN"};
    if(module.hot) {
      // 1738064242325
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  